import '../App.css';

import { FC } from 'react';
import { useLoaderData } from 'react-router';

import { Posts } from '@/components/Posts/Posts';

interface FeedProps {
  status: PetStatus;
}

export const Feed: FC<FeedProps> = ({ status }) => {
  const initialData = useLoaderData() as {
    results: Array<Pet>;
    next: string | null;
  };

  return <Posts status={status} initialData={initialData} />;
};
